export enum NoteLinkConstants {
  GET_ALL_SUCCESS = 'NoteLinkConstants_GET_ALL_SUCCESS',
  GET_SINGLE_SUCCESS = 'NoteLinkConstants_GET_SINGLE_SUCCESS',
  CREATE_SUCCESS = 'NoteLinkConstants_CREATE_SUCCESS',
  UPDATE_SUCCESS = 'NoteLinkConstants_UPDATE_SUCCESS',
  CLEAR_CURRENT = 'NoteLinkConstants_CLEAR_CURRENT',
  DELETE = 'NoteLinkConstants_DELETE',
  ERROR = 'NoteLinkConstants_ERROR',
}
